import React, { useMemo, useState } from "react"
import { Search, UserRound, UserRoundCheck } from "lucide-react"

export default function MemberAssignmentPicker({ members = [], value, onAssign, disabled = false }) {
  const [query, setQuery] = useState("")
  const selected = members.find(member => member.memberId === value)
  const visible = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase()
    return [...members]
      .filter(member => !normalized || (member.displayName || "").toLocaleLowerCase().includes(normalized))
      .sort((left, right) => (left.displayName || "").localeCompare(right.displayName || ""))
  }, [members, query])

  return <details className="group-task-assignee" onClick={event => event.stopPropagation()} onPointerDown={event => event.stopPropagation()} onKeyDown={event => event.stopPropagation()}>
    <summary><UserRound size={14} /> {selected?.displayName || "Assign someone"}</summary>
    <div className="group-task-assignee-menu">
      <label><Search size={15} /><span className="sr-only">Search group members by first or last name</span><input type="search" value={query} onChange={event => setQuery(event.target.value)} placeholder="Search first or last name" autoComplete="off" /></label>
      <div className="group-task-assignee-results">
        <button type="button" className={!value ? "is-selected" : ""} disabled={disabled} onClick={event => { onAssign(null); event.currentTarget.closest("details")?.removeAttribute("open") }}><UserRound size={15} /> Unassigned</button>
        {visible.map(member => <button type="button" key={member.memberId} className={member.memberId === value ? "is-selected" : ""} disabled={disabled} onClick={event => { onAssign(member.memberId); event.currentTarget.closest("details")?.removeAttribute("open") }}><UserRoundCheck size={15} /><span>{member.displayName || "Member"}{member.isFounder && <small>Founder</small>}</span></button>)}
        {visible.length === 0 && <p>No members match that name.</p>}
      </div>
    </div>
  </details>
}
